/**
 * An element which, when added to <Head>, shows a Smart App Banner on supported iOS devices.
 *
 * Why isn't this a React compenent? Helmet does not allow nested components.
 * So this provides a JSX.Element which can be used there.
 *
 * @see https://developer.apple.com/documentation/webkit/promoting_apps_with_smart_app_banners
 *
 * @param appId The App Store ID off the app to show a banner for.
 * @param deeplinkUrl The deeplink provided to the app when tapping the banner.
 * @returns
 */
export const iOSSmartAppBanner = (
  appId: string,
  deeplinkUrl: string | undefined = undefined
): JSX.Element => {
  const contents = [`app-id=${appId}`];

  if (deeplinkUrl) {
    contents.push(`app-argument=${deeplinkUrl}`);
  }

  return <meta name="apple-itunes-app" content={contents.join(',')} />;
};
